import config from './Config';

const VariationMixin = {
    props: {
        variation: { type: String, default: '' }
    },
    watch: {
        variation: function (value) {
            this.defaultParams = this.getVariation(value);
            this.loadDefaultParams();
        }
    },
    data () {
        return {
            params: {},
            defaultParams: {}
        };
    },
    methods: {
        getVariation (value) {
            const type = this.$options.variationType;
            // console.log('[variation-mixin]', '[get-variation]', type);
            // console.log('[variation-mixin]', '[get-variation]', variation);
            return config.getVariation(type, value);
        },

        setParam (name, value) {
            const params = this.params;
            if (value === null) {
                const defaultParams = this.defaultParams;
                const instanceValue = this[name];
                if (instanceValue === null) {
                    params[name] = defaultParams[name];
                } else {
                    params[name] = instanceValue;
                }
            } else {
                params[name] = value;
            }
        },

        loadDefaultParams (init = false) {
            if (init === true) {
                this.defaultParams = this.getVariation(this.variation);
            }
            const defaultParams = this.defaultParams;
            const params = this.params;
            for (const key in defaultParams) {
                const instanceValue = this[key];
                if (instanceValue === null) {
                    params[key] = defaultParams[key];
                } else {
                    params[key] = instanceValue;
                }
            }
        }
    }
};

export default VariationMixin;
